<template>
  <div class="block py-24 sm:py-48" :class="{'w-full': inGrid}">
    <div class="container xxl:px-24">
      <div
        class="text-promo text-center rounded-lg py-48 sm:py-64 md:py-80"
        :style="{ 'background-color': component.backgroundColor }"
      >
        <h2 v-if="component.title" class="sm:w-3/4 lg:w-1/2 mx-auto">
          {{ component.title }}
        </h2>
        <div
          class="mb-24 md:mb-28 wysiwyg mx-auto px-32 sm:px-0 sm:w-3/4 lg:w-1/2"
          v-html="component.content"
        />
        <a
          v-if="component.link"
          :href="component.link.url"
          :target="component.link.target"
          class="btn btn--lg w-fit-content mx-auto"
          :class="{
            'btn--primary': component.buttonColorTheme === 'blue-theme',
            'btn--danger': component.buttonColorTheme === 'red-theme',
            'btn--secondary btn--ghost':
              component.buttonColorTheme === 'transparent-theme',
          }"
        >
          {{ component.link.title }}
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import ComponentBlock from '~/models/component-block';

import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    component: {
      type: ComponentBlock,
      required: true,
    },
    inGrid: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
});
</script>
